import { useState, useEffect, useRef, useCallback } from 'react';

export function useWebSocket(token) {
  const [logs, setLogs] = useState({});
  const [statuses, setStatuses] = useState({});
  const wsRef = useRef(null);

  const connect = useCallback(() => {
    if (!token) return;

    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    const host = window.location.host;
    const ws = new WebSocket(`${protocol}//${host}/ws?token=${token}`);

    ws.onopen = () => {
      console.log('WebSocket conectado');
    };

    ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);

        if (data.type === 'log') {
          setLogs((prev) => ({
            ...prev,
            [data.projectId]: [
              ...(prev[data.projectId] || []),
              { timestamp: data.timestamp, message: data.message, level: data.level },
            ],
          }));
        }

        if (data.type === 'status') {
          setStatuses((prev) => ({ ...prev, [data.projectId]: data.status }));
        }
      } catch (err) {
        console.error('Erro ao processar mensagem WS:', err);
      }
    };

    ws.onclose = () => {
      console.log('WebSocket desconectado, reconectando em 3s...');
      setTimeout(connect, 3000);
    };

    wsRef.current = ws;
  }, [token]);

  useEffect(() => {
    connect();
    return () => {
      if (wsRef.current) wsRef.current.close();
    };
  }, [connect]);

  const clearLogs = useCallback((projectId) => {
    setLogs((prev) => ({ ...prev, [projectId]: [] }));
  }, []);

  return { logs, statuses, clearLogs };
}
